<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm"
 > */
  <!-- State 1: Confirmation dialog -->
  @if (errorType() === null) {
    <app-confirmation-dialog
      layout="start"
      [title]="dialogTitle"
      [description]="dialogDescription"
      [itemName]="reasonName()"
      [confirmContent]="dialogConfirmText"
      [cancelContent]="dialogCancelText"
      [isLoading]="isSubmitting()"
      [error]="deleteError() || ''"
      (onSubmit)="confirmDelete()"
      (onCancel)="cancel()" />
  }

 

</div>